<template>
    <div
        class="listItem"
    >
        <router-link :to="{name:'recipes', query: { recipe: recipe.id }}">
            <div class="listIContainer">
                <LikeButton  :recipe_id="recipe.id" ></LikeButton>
                <div class="imgBox">
                    <img class="img-fluid" :src="recipe.image ? recipe.image : getStaticImage('logo.png')"></img>
                </div>
                {{recipe.title}}
            </div>
        </router-link>
    </div>
</template>

<script>
    import LikeButton from "./LikeButton"
    export default {
        name: "RecipeListItem",
        props: ["recipe"],
        components: {LikeButton}
    }
</script>
